module.exports = __webpack_public_path__ + "static/media/giraffe.21d61e43.svg";